module.exports = __webpack_public_path__ + "static/about-team-bg-6639924651b07780fe5ff06bf0a521f8.jpg";